import React from "react";
import {Grid} from "@mui/material";
import {KeySnapshot, KeyVault} from "../../api/Model";
import {SetState} from "../../util/FormHandlers";
import {filterSerializer} from "../../util/FilterSerializer";
import {ResidenceFilter} from "../../components/filter-fields/ResidenceFilter";
import {HierarchyEmployee} from "../../util/EmployeeHierarchy";
import {today} from "../../util/DateUtil";
import {EmployeeKeyHistory} from "../../api/EmployeeKeyHistoryStore";
import {DateFilter} from "../../components/filter-fields/DateFilter";
import {KeyVaultFilter} from "../../components/filter-fields/KeyVaultFilter";
import {matchResidence, Residence, ResidenceModel} from "../../api/ResidenceStore";
import {andFilter, applyFilter, filterValue, matchesSome, matchIfSelected} from "../../util/FilterUtil";


export interface EmployeePortraitFilterForm {
    date: string;
    keyVault: KeyVault;
    residency: Residence | null;
}

export const employeePortraitFilterFormSerializer = (
    defaultKeyVault: KeyVault,
    keyVaults: KeyVault[],
    residenceModel: ResidenceModel,
) => filterSerializer<EmployeePortraitFilterForm>(
    {
        date: today(),
        keyVault: defaultKeyVault,
        residency: residenceModel.residents,
    },
    b => {
        b.str('date');
        b.keyVault('keyVault', keyVaults);
        b.residency('residency', residenceModel);
    }
);

export function filterEmployeePortraits(
    tableRows: HierarchyEmployee[],
    employeeKeyHistory: EmployeeKeyHistory,
    filter: EmployeePortraitFilterForm,
): HierarchyEmployee[] {
    const historyFilter = andFilter<KeySnapshot>(
        filterValue<KeySnapshot, {from: string, to: string}>(
            ({from, to}) => !filter.date || (from <= filter.date && filter.date <= to),
            snapshot => ({
                from: snapshot.historyRecord.from ?? '1900-01-01',
                to: snapshot.historyRecord.to ?? '9999-12-31',
            }),
        ),
        filterValue(
            matchIfSelected(filter.keyVault.id),
            snapshot => snapshot.historyRecord.vault.id,
        ),
    );

    return applyFilter<HierarchyEmployee>(tableRows, andFilter(
        filterValue(
            matchResidence(filter.residency),
            employee => employee,
        ),
        employee => matchesSome(
            employeeKeyHistory.get(employee),
            historyFilter,
        ),
    ));
}

export function EmployeePortraitListFilter({filter, setFilter}: {
    filter: EmployeePortraitFilterForm,
    setFilter: SetState<EmployeePortraitFilterForm>,
}) {
    return (
        <Grid container spacing={2} alignItems="center">
            <KeyVaultFilter filter={filter} setFilter={setFilter}/>
            <DateFilter filter={filter} setFilter={setFilter} property="date" label="On Date"/>
            <ResidenceFilter filter={filter} setFilter={setFilter}/>
        </Grid>
    );
}
